import { combineReducers } from 'redux';

import { form } from './form.reducer';
import { user } from './user.reducer';
import { event } from './event.reducer';
import { alert } from './alert.reducer';
import { group } from './group.reducer';
import { client } from './client.reducer'
import { intake } from './intake.reducer';
import { doctor } from './doctor.reducer'
import { patient } from './patient.reducer'
import { careplan } from './careplan.reducer'
import { messages } from './message.reducer';
import { provider } from './provider.reducer';
import { telehealth } from './telehealth.reducer';
import { conversation } from './conversation.reducer';
import { questionnaire } from './questionnaire.reducer';
import { authentication } from './authentication.reducer';
import { documentBuilder } from './document-builder.reducer';
import { questionLibrary } from './question-library.reducer';

import { authenticationConstants } from '../_constants/authentication.constants';

const appReducer = combineReducers({
  form,
  user,
  alert,
  event,
  group,
  client,
  intake,
  doctor,
  patient,
  careplan,
  messages,
  provider,
  telehealth,
  conversation,
  questionnaire,
  authentication,
  documentBuilder,
  questionLibrary,
});

const rootReducer = (state, action) => {
  if (action.type === authenticationConstants.AUTH_CLEAR) {
    state = {}
  }

  return appReducer(state, action)
}

export default rootReducer